export default __webpack_public_path__ + "static/media/Logo12.8763d1c0.svg";